

import React from 'react';
import { FederatedModule } from '@bfme-technology/spa';
import { getResolvedMfeProps } from '../Dashboard.utils';



import type { SavingsGoalsProps } from './SavingsGoals.types';

export const SavingsGoals: React.FC<SavingsGoalsProps> = ({ routesLoading = false, routes = [] }) => {
  const route = routes.find((r) => r.key === 'mfe-investing');

  if (routesLoading) {
    return (
      <section className="glass-panel p-5 md:p-6 flex flex-col gap-4 items-center justify-center min-h-[150px]">
        <div className="text-text-muted text-xs">Loading Savings Goals MFE...</div>
      </section>
    );
  }

  if (!route) {
    return (
      <section className="glass-panel p-5 md:p-6 flex flex-col gap-4">
        <div className="flex justify-between items-center">
          <h3 className="text-sm md:text-base font-bold text-text-primary">Active Savings Goals</h3>
          <span className="bg-primary-accent-bg text-primary-accent px-2 py-0.5 rounded-lg text-[10px] font-extrabold">3 Active</span>
        </div>

        <div className="flex flex-col gap-4">
          {/* Goal 1 */}
          <div className="flex flex-col gap-1.5">
            <div className="flex justify-between text-xs">
              <span className="font-bold text-text-primary">Emergency Fund</span>
              <span className="text-text-secondary font-semibold">$21,500 / $25,000 (86%)</span>
            </div>
            <div className="h-2 w-full bg-bg-deep border border-border-color rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-primary-teal to-primary-cyan rounded-full" style={{ width: '86%' }}></div>
            </div>
          </div>

          {/* Goal 2 */}
          <div className="flex flex-col gap-1.5">
            <div className="flex justify-between text-xs">
              <span className="font-bold text-text-primary">Tesla Model Y</span>
              <span className="text-text-secondary font-semibold">$38,000 / $55,000 (69%)</span>
            </div>
            <div className="h-2 w-full bg-bg-deep border border-border-color rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-accent-violet to-accent-magenta rounded-full" style={{ width: '69%' }}></div>
            </div>
          </div>

          {/* Goal 3 */}
          <div className="flex flex-col gap-1.5">
            <div className="flex justify-between text-xs">
              <span className="font-bold text-text-primary">Paris Vacation</span>
              <span className="text-text-secondary font-semibold">$4,500 / $6,000 (75%)</span>
            </div>
            <div className="h-2 w-full bg-bg-deep border border-border-color rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-pink-500 to-rose-500 rounded-full" style={{ width: '75%' }}></div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  const resolved: any = getResolvedMfeProps(route);
  const { key, ...mfeProps } = resolved;
  return (
    <FederatedModule
      {...mfeProps}
      mfeType="federated"
      scope="mfe_investing"
      module="./SavingsGoals"
    />
  );
};
